export const PURPOSES = {
  call: 'phone_call',
  quote: 'prepare_a_quote',
  work: 'perform_work',
  follow: 'follow_up_on_completed_work',
  other: 'other',
};

export const PURPOSES_MAP = {
  [PURPOSES.call]: {
    value: PURPOSES.call,
    short: 'Call',
    long: 'Phone call',
  },
  [PURPOSES.quote]: {
    value: PURPOSES.quote,
    short: 'Quote',
    long: 'Prepare a quote',
  },
  [PURPOSES.work]: {
    value: PURPOSES.work,
    short: 'Work',
    long: 'Perform work',
  },
  [PURPOSES.follow]: {
    value: PURPOSES.follow,
    short: 'Follow-up',
    long: 'Follow-up on completed work',
  },
  [PURPOSES.other]: {
    value: PURPOSES.other,
    short: 'Other',
    long: 'Other',
  },
};
